// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, Tooltip, PieChart, Pie, Cell } from 'recharts';

// Utilities
import { colors } from 'common/utils/helpers';

// Components
import CustomTooltip from 'admin/engagement/reporting/components/CustomTooltip';
import CustomPieChartLabel from 'admin/engagement/reporting/components/CustomPieChart/CustomPieChartLabel';
import CustomPieChartLabelLine from 'admin/engagement/reporting/components/CustomPieChart/CustomPieChartLabelLine';

const pieLabelText = (props) => <CustomPieChartLabel {...props} width={200} fontSize={14} />;

const tooltipAttributes = [
  { tooltipLabel: 'Percentage', payloadKey: 'percentage', percentage: true },
  { tooltipLabel: 'Count', payloadKey: 'count' },
];

const PieReportChart = ({ data, chartRef }) => {
  const dataFiltered = data.filter((entry) => entry.percentage > 0);

  return (
    <div className="single-select-report-chart">
      {/* eslint-disable react/no-array-index-key, react/prop-types */}
      <ResponsiveContainer width="100%" aspect={1.5}>
        <PieChart margin={{ top: 20, right: 30, left: 20, bottom: 20 }} ref={chartRef}>
          <Tooltip
            content={<CustomTooltip attributes={tooltipAttributes} />}
            isAnimationActive={false}
          />
          <Pie
            data={dataFiltered}
            dataKey="percentage"
            isAnimationActive={false}
            labelLine={CustomPieChartLabelLine}
            label={pieLabelText}
          >
            {dataFiltered.map((entry, index) => (
              <Cell key={index} fill={colors[index % colors.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      {/* eslint-enable react/no-array-index-key, react/prop-types */}
    </div>
  );
};

PieReportChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      percentage: PropTypes.number,
      top: PropTypes.bool,
    })
  ).isRequired,
  chartRef: PropTypes.shape({
    current: PropTypes.objectOf(PropTypes.shape({})),
  }).isRequired,
};

export default PieReportChart;
